import React, { useEffect, useState } from "react";
import "@/App.css";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import CredentialsStrip from "@/components/site/CredentialsStrip";
import PracticeAreas from "@/components/site/PracticeAreas";
import About from "@/components/site/About";
import OfCounsel from "@/components/site/OfCounsel";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    return window.localStorage.getItem("kb-theme") || "light";
  });

  const toggleTheme = () =>
    setTheme((t) => (t === "light" ? "dark" : "light"));

  useEffect(() => {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("theme-dark");
    } else {
      root.classList.remove("theme-dark");
    }
    try {
      window.localStorage.setItem("kb-theme", theme);
    } catch (e) {
      /* ignore */
    }
  }, [theme]);

  return (
    <div className={`App ${theme === "dark" ? "theme-dark" : ""}`} data-testid="app-root">
      <Nav theme={theme} onToggleTheme={toggleTheme} />
      <main>
        <Hero />
        <CredentialsStrip />
        <PracticeAreas />
        <About />
        <OfCounsel />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
